const nav = document.querySelector(".navigation-in-page");
const priceCalcBtn = document.querySelector(".price-calculation-model__btn-container");

if (nav && priceCalcBtn) {
  const observerOptions = {
    root: null,
    rootMargin: "0px 0px -90% 0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        priceCalcBtn.classList.add("price-calculation-model__btn--active");
      } else {
        priceCalcBtn.classList.remove("price-calculation-model__btn--active");
      }
    });
  }, observerOptions);

  observer.observe(nav);
}
